module.exports = __webpack_public_path__ + "img/counter-icon-4.ce210805.svg";